import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import './bic-loader.css'

const EE_OPTIMAL_MODAL = 'EEOptimalModal'

const BICFormModal = Loadable(() => import('./BICForm'))

export const createEEOptimalBICNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'eeoptimal',
  text: translateFn('mnu_credit_purchase'),
  identity: EE_OPTIMAL_MODAL,
  permission: 'BIC_WIZARD',
  component: BICFormModal,
}))
